module.exports = __webpack_public_path__ + "enterprise-software-ux-design.3vNmW9nM.svg";